import React from 'react';
import View from './View';
import { useUser } from 'context';
export var EvolusCreditContainer = function () {
    var account = useUser().account;
    var evolusCredit = null;
    return evolusCredit ? (React.createElement(View, { isLoading: false, errors: undefined, accountId: account === null || account === void 0 ? void 0 : account.id, totalAmountDue: 0, totalAmountDueThisWeek: 0, paymentMethods: [] })) : null;
};
